import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
var SpinnerIcon = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        viewBox: "0 0 50 50",
        children: /*#__PURE__*/ _jsx("circle", {
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none",
            strokeWidth: "5"
        })
    });
};
export default /*#__PURE__*/ memo(SpinnerIcon);
